// import React from "react";

// const facilities = [
//   {
//     id: 1,
//     title: "Golf View Restaurant",
//     desc: "Guests can avail facilities at the Golf View Restaurant and enjoy premium dining in a serene atmosphere.",
//   },
//   {
//     id: 2,
//     title: "Play Golf with Fair Fee",
//     desc: "Guests are welcome to play golf with a fair fee, experiencing the beautifully maintained course.",
//   },
//   {
//     id: 3,
//     title: "Guest Room Facilities",
//     desc: "Guests can avail guest room facilities for a comfortable and convenient stay within the club premises.",
//   },
//   {
//     id: 4,
//     title: "Pro Shop Facilities",
//     desc: "Guests can access the Pro Shop facilities for golfing essentials and accessories.",
//   },
// ];

// const FacilitiesForGuests = () => {
//   return (
//     <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
//       {/* Page Title */}
//       <h1 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-green-700">
//         Facilities for Guests
//       </h1>

//       {/* Timeline */}
//       <div className="relative max-w-3xl mx-auto border-l border-green-300">
//         {facilities.map((facility) => (
//           <div key={facility.id} className="mb-10 ml-6">
//             {/* Circle marker */}
//             <span className="absolute -left-3 flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 bg-green-600 rounded-full ring-4 ring-white text-white text-xs sm:text-sm font-bold">
//               {facility.id}
//             </span>

//             {/* Content Card */}
//             <div className="p-4 sm:p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition">
//               <h2 className="text-lg sm:text-xl font-semibold text-green-700">
//                 {facility.title}
//               </h2>
//               <p className="mt-2 text-sm sm:text-base text-gray-700 leading-relaxed">
//                 {facility.desc}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default FacilitiesForGuests;

import React from "react";
import {
  Users,
  Coffee,
  Flag,
  Bed,
  ShoppingBag,
  Sparkles,
  CheckCircle,
  ArrowRight,
  Star,
  MapPin,
  Calendar,
  Shield,
} from "lucide-react";

const facilities = [
  {
    id: 1,
    title: "Golf View Restaurant",
    desc: "Guests can avail facilities at the Golf View Restaurant and enjoy premium dining in a serene atmosphere.",
    icon: <Coffee className="w-6 h-6" />,
    color: "from-amber-500 to-orange-500",
    bg: "bg-gradient-to-br from-amber-50 to-orange-50",
    border: "border-amber-100",
    features: ["Premium dining", "Riverside views", "Fine cuisine"],
  },
  {
    id: 2,
    title: "Play Golf with Fair Fee",
    desc: "Guests are welcome to play golf with a fair fee, experiencing the beautifully maintained course.",
    icon: <Flag className="w-6 h-6" />,
    color: "from-emerald-500 to-lime-500",
    bg: "bg-gradient-to-br from-emerald-50 to-lime-50",
    border: "border-emerald-100",
    features: ["9-hole course", "Equipment rental", "Professional guidance"],
  },
  {
    id: 3,
    title: "Guest Room Facilities",
    desc: "Guests can avail guest room facilities for a comfortable and convenient stay within the club premises.",
    icon: <Bed className="w-6 h-6" />,
    color: "from-blue-500 to-indigo-500",
    bg: "bg-gradient-to-br from-blue-50 to-indigo-50",
    border: "border-blue-100",
    features: ["Luxury rooms", "Room service", "Scenic views"],
  },
  {
    id: 4,
    title: "Pro Shop Facilities",
    desc: "Guests can access the Pro Shop facilities for golfing essentials and accessories.",
    icon: <ShoppingBag className="w-6 h-6" />,
    color: "from-purple-500 to-pink-500",
    bg: "bg-gradient-to-br from-purple-50 to-pink-50",
    border: "border-purple-100",
    features: ["Premium brands", "Expert advice", "Latest equipment"],
  },
];

const FacilitiesForGuests = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-2xl">
                <Users className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Premium{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Guest Facilities</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-emerald-100 max-w-3xl mx-auto mb-8">
            Experience world-class amenities and services designed for your
            comfort and enjoyment at RGCC
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-emerald-200">
              <Star className="w-5 h-5" />
              <span>Premium Services</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <Shield className="w-5 h-5" />
              <span>VIP Treatment</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <Calendar className="w-5 h-5" />
              <span>Flexible Access</span>
            </div>
          </div>
        </div>
      </div>

      {/* Facilities Timeline */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 transform md:-translate-x-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-emerald-300 via-lime-300 to-emerald-300"></div>

          {facilities.map((facility, index) => {
            const isEven = index % 2 === 0;

            return (
              <div
                key={facility.id}
                className="relative mb-16 md:mb-24 last:mb-0"
              >
                {/* Timeline Dot */}
                <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 z-10">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-md opacity-50"></div>
                    <div className="relative w-14 h-14 rounded-full bg-white border-4 border-emerald-500 flex items-center justify-center shadow-2xl">
                      <div className="text-emerald-600">{facility.icon}</div>
                    </div>
                    <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-6 h-6 bg-emerald-500 rounded-full flex items-center justify-center text-white text-sm font-bold shadow-lg">
                      {facility.id}
                    </div>
                  </div>
                </div>

                {/* Content Card */}
                <div
                  className={`ml-20 md:ml-0 md:w-5/12 ${
                    isEven ? "md:mr-auto md:pr-12" : "md:ml-auto md:pl-12"
                  }`}
                >
                  <div
                    className={`${facility.bg} ${facility.border} rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 overflow-hidden group`}
                  >
                    {/* Decorative Corner */}
                    <div
                      className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${facility.color} opacity-10 rounded-bl-full`}
                    ></div>

                    {/* Icon Badge */}
                    <div
                      className={`w-16 h-16 rounded-xl ${facility.bg} flex items-center justify-center mb-6 border ${facility.border} shadow-lg`}
                    >
                      <div
                        className={`bg-gradient-to-r ${facility.color} bg-clip-text text-transparent`}
                      >
                        {facility.icon}
                      </div>
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {facility.title}
                    </h2>

                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {facility.desc}
                    </p>

                    {/* Features List */}
                    <div className="mb-6">
                      <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                        <Sparkles className="w-4 h-4 text-emerald-500" />
                        Key Features
                      </h4>
                      <ul className="space-y-2">
                        {facility.features.map((feature, idx) => (
                          <li
                            key={idx}
                            className="flex items-center gap-3 text-gray-600"
                          >
                            <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Action Button */}
                    <button className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-800 font-medium group/btn transition-colors duration-300">
                      <span>Learn more about this facility</span>
                      <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Information */}
        <div className="mt-20 bg-gradient-to-r from-emerald-50 to-lime-50 rounded-2xl p-8 md:p-12 border border-emerald-100">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-emerald-100 to-lime-100 border-2 border-emerald-200 mb-6">
              <Shield className="w-8 h-8 text-emerald-600" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Guest Experience at RGCC
            </h3>
            <p className="text-gray-600 text-lg mb-6">
              Our guest facilities are designed to provide an exceptional
              experience. From premium dining to championship golf, every aspect
              is crafted to ensure your visit is memorable and enjoyable.
            </p>
            <button className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl">
              <MapPin className="w-4 h-4" />
              Plan Your Visit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilitiesForGuests;
